const _excluded = ["children", "className", "header", "subheader", "actions", "loading", "style", "height", "width", "minWidth", "maxWidth", "disableRightGutter", "disableLeftGutter", "skin", "variant", "onClickBack", "testId", "hideActionsOnMobile", "onScroll"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import React, { useMemo, useState } from 'react';
import cn from 'classnames';
import { useDevice } from "../Device";
import { PageHeader } from "../PageHeader";
import styles from "./Page.module.scss";
import { GetPageTID } from "./Page.utils";
import { PageContentHeaderContext } from "./PageContentHeader";

/** Renders a page to the right of a sidebar. */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const Page = /*#__PURE__*/React.forwardRef(function Page(props, ref) {
  const {
      children,
      className,
      header,
      subheader,
      actions,
      loading,
      style,
      height,
      width,
      minWidth,
      maxWidth,
      disableRightGutter,
      disableLeftGutter,
      skin = 'primary',
      variant = 'default',
      onClickBack,
      testId,
      hideActionsOnMobile,
      onScroll
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  const {
    isMobileDevice
  } = useDevice();
  const [isScrolled, setIsScrolled] = useState(false);
  const [contentHeaderEl, setContentHeaderEl] = useState(null);
  const {
    PageTestIds
  } = useMemo(() => GetPageTID(testId), [testId]);
  const renderedStyle = useMemo(() => _objectSpread(_objectSpread({}, style), {}, {
    '--pageHeight': height,
    width: isMobileDevice ? undefined : width,
    '--min-width': isMobileDevice ? undefined : minWidth,
    '--max-width': isMobileDevice ? undefined : maxWidth
  }), [style, height, width, minWidth, maxWidth, isMobileDevice]);
  function handleScroll(e) {
    setIsScrolled(e.currentTarget.scrollTop > 0);
    onScroll === null || onScroll === void 0 || onScroll(e);
  }
  return /*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread(_objectSpread({}, rest), testId != null ? {
    'data-testid': testId
  } : {}), {}, {
    className: cn(styles.root, styles["".concat(skin, "Skin")], {
      [styles.disableRightGutter]: disableRightGutter,
      [styles.disableLeftGutter]: disableLeftGutter,
      [styles.containedHeight]: variant === 'containedHeight',
      [styles.mobile]: isMobileDevice
    }, className),
    style: renderedStyle,
    ref: ref,
    onScroll: handleScroll,
    children: [/*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread({
      className: cn(styles.stickyToTop, {
        [styles.isScrolled]: isScrolled
      })
    }, testId != null ? {
      'data-testid': PageTestIds.StickyHeader()
    } : {}), {}, {
      children: [header && /*#__PURE__*/_jsx(PageHeader, {
        title: header,
        loading: loading,
        subheader: subheader,
        actions: actions,
        hideActions: hideActionsOnMobile && isMobileDevice,
        onClickBack: onClickBack,
        testId: testId
      }), /*#__PURE__*/_jsx("div", {
        className: cn(isMobileDevice && styles.contentHeader),
        ref: setContentHeaderEl
      })]
    })), /*#__PURE__*/_jsx("div", {
      className: styles.content,
      "data-testid": testId && "".concat(testId, "-page-content"),
      children: /*#__PURE__*/_jsx(PageContentHeaderContext.Provider, {
        value: contentHeaderEl,
        children: children
      })
    })]
  }));
});